module.exports = __webpack_public_path__ + "static/media/map-bg.11b4c39e.svg";